<template>
  <div class="productList" ref="container">
    <div class='slider-banner'>
        <img src='https://xk.ahifeng.com/uploads/attach/2020/09/20200923/ddc39d7c25fc3771cac11de1b8551c28.jpg' />
    </div>
    <div class="nav-list clearfix">
        <router-link
        class='item'
        v-for="(item, index) in cateList"
        :key="index"
        :to="{
            path: '/goods_list',
            query: { id: item.categoryid, title: item.title }
        }"
        >
            <div class='title'>{{item.title}}</div>
            <div class="line" v-if="(index+1)%4 !== 0"></div>
        </router-link>
    </div>
    <div
      class="list acea-row row-between-wrapper"
      ref="container"
      style="margin-top: 0.2rem;"
    >
      <div
        @click="goDetail(item)"
        v-for="(item, index) in host_product"
        :key="index"
        class="item"
        :title="item.store_name"
      >
        <div class="pictrue">
          <img :src="item.image" />
        </div>
        <div class="text">
          <div class="name line1">{{ item.store_name }}</div>
          <div
            class="money font-color-red"
          >
            ￥<span class="num">{{ item.price }}</span>
          </div>
          <div
            class="vip acea-row row-between-wrapper"
          >
            <div class="vip-money" v-if="item.vip_price && item.vip_price > 0">
              ￥{{ item.vip_price }}<img src="@assets/images/vip.png" />
            </div>
            <div>已售{{ item.sales }}件</div>
          </div>
        </div>
      </div>
    </div>
    <Loading :loaded="loadend" :loading="loading"></Loading>
    <div
      class="noCommodity"
      v-cloak
      style="background-color: #fff;"
      v-if="host_product.length === 0"
    >
      <div class="noPictrue">
        <img src="@assets/images/noGood.png" class="image" />
      </div>
    </div>
  </div>
</template>

<script>
import { getHostProducts,getMultigraphList } from "@api/store";
import Loading from "@components/Loading";

export default {
  name: "Citys",
  components: {
    Loading
  },
  props: {},
  data: function() {
    return {
      cateList:[],
      host_product:[]
    };
  },
  watch: {
    
  },
  mounted: function() {
    this.getCates();
    this.getHostProduct();
  },
  methods: {
    // 商品详情跳转
    goDetail(item) {
      if (item.activity && item.activity.type === "1") {
        this.$router.push({
          path:
            "/activity/seckill_detail/" +
            item.activity.id +
            "/" +
            item.activity.time +
            "/1"
        });
      } else if (item.activity && item.activity.type === "2") {
        this.$router.push({
          path: "/activity/dargain_detail/" + item.activity.id
        });
      } else if (item.activity && item.activity.type === "3") {
        this.$router.push({
          path: "/activity/group_detail/" + item.activity.id
        });
      } else {
        this.$router.push({ path: "/detail/" + item.id });
      }
    },
    getCates: function(){
        var that = this;
        getMultigraphList().then(res => {
            that.cateList = res.data;
        });
    },
    getHostProduct: function(){
        var that = this;
        getHostProducts(1,8).then(res => {
            that.host_product = res.data;
        });
    }
  }
};
</script>
<style scoped>
.noCommodity {
  border-top: 3px solid #f5f5f5;
  padding-bottom: 1px;
}
</style>
